module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "counters"
  }, _vm._l((_vm.matches), function(label) {
    return _c('li', {
      staticClass: "flex-all"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "bold"
    }, [_c('div', [_vm._v(_vm._s(label.title))]), _vm._v(" "), _c('h6', {
      staticClass: "bold"
    }, [_vm._v("\n                    " + _vm._s(label.text) + "\n                    "), (_vm.product) ? _c('span', [_vm._v(" | " + _vm._s(_vm.formatPrice(label.value)) + "€")]) : _vm._e()])])]), _vm._v(" "), _c('calculator', {
      attrs: {
        "object": label,
        "field": "quantity",
        "editable": _vm.editable
      },
      on: {
        "mathDone": _vm.mathDone
      }
    })], 1)
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0b1da424", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1da424"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/PriceCounters.vue
// module id = 1641
// module chunks = 0